import { NgClass } from '@angular/common';
import { Component, Optional } from '@angular/core';
import { IconComponent } from 'components/layout/icon/icon.component';
import { CredentialsDirective } from 'directives/credential.directive';
import { CredentialType } from 'enums/CredentialType';
import { InputType } from 'enums/InputType';
import { LanguageVariableModel } from 'models/generated/Language.Api.Models.LanguageVariable';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { LanguageService } from 'services/language.service';
import { WorkspaceService } from 'services/workspace.service';
import { EditableContent, SingleFocusService } from 'components/input/editable-content/editable-content.component';
import { Layout } from 'modules/layout';
import { Inputs } from 'modules/inputs';

@Component({
	selector: 'language-editor',
	templateUrl: './language-editor.component.html',
	styleUrls: ['./language-editor.component.scss'],
	providers: [WorkspaceService, SingleFocusService],
	imports: [CredentialsDirective, NgClass, EditableContent, IconComponent, Layout, Inputs]
})
@CredentialRequired(CredentialType.EditLanguageTranslations)
export class LanguageEditorComponent {
	inputTypeEnum = InputType;

	editLanguageTranslationsCredential = CredentialType.EditLanguageTranslations;
	public active = false;
	public title = '';
	public variables: LanguageVariableModel[] = [];
	public missingVariables = 0;
	constructor(private readonly languageService: LanguageService, private readonly translate: TranslatePipe, @Optional() private singleFocus: SingleFocusService) {
		languageService.currentLanguageVariables().subscribe(variables => {
			this.variables = variables;
			this.missingVariables = variables.filter(variable => variable.text === '').length;
		});
		// Add translate variables in constructor to avoid ExpressionChangedAfterItHasBeenCheckedError in console for this component only
		this.title = this.translate.transform('language-editor.header');
	}
	saveChanges(variable: LanguageVariableModel, value: string) {
		variable.text = value;
		this.languageService.saveLanguageVariable(variable);
	}
	keepFocus(event: Event) {
		if (event.target instanceof HTMLInputElement) event.target.focus();
	}
	confirmEdit() {
		this.singleFocus?.activeComponent?.confirmEdit();
	}
	getTextVariables(textVariables: any): string {
		let variables = '';
		for (let property in textVariables) {
			if (!textVariables.hasOwnProperty(property)) continue;
			if (variables != '') variables += ', ';
			variables += '${' + property + '}';
		}
		return variables;
	}
}
